import { combineReducers } from '@reduxjs/toolkit';

import dropdown from '@/components/Dropdown/states/staticDropdownStore';
import crews from '@/features/partners/states/crewsStore';
import operatingCrew from '@/features/settings/states/operatingCrewStore';
import sidePanel from '@/features/settings/states/sidePanelStore';
import space from '@/features/space/spaceForm/states/spaceFormStore';
import venue from '@/features/venue/venueForm/states/venueFormStore';
import onetimeWork from '@/features/works/store/onetimeWorkStore';
import workFile from '@/features/works/store/workFileStore';
import error from '@/states/errorSlice';
import position from '@/states/positionSlice';

// Reducers
import toast from '../components/Toast/toastSlice';
import layout from '../features/layout/layoutSlice';

export default combineReducers({
  toast,
  layout,
  error,
  position,
  dropdown,
  venue,
  space,
  crews,
  operatingCrew,
  sidePanel,
  onetimeWork,
  workFile,
});
